export enum FEATURES {
  CHANGE_INSTALLATION_ADDRESS = 'change_installation_address',
  CONVERSATIONAL_AI = 'conversational_ai',
  MAINTENANCE = 'maintenance',
  PAGE_ENTERTAINMENT = 'page_entertainment',
  SERVICE_PAGE = 'service_page',
  STREAMING_IN_TV_PACKAGES = 'streaming_in_tv_packages',
  STREAMING_SKYSHOWTIME_ENABLED = 'streaming_skyshowtime_enabled',
  PAYMENT_ARRANGEMENT_WEBVIEW_ENABLED = 'payment_arrangement_webview_enabled',
  PRODUCT_SERVICE = 'product_service',
  ORDER_DELAYED_NOTIFICATION = 'order_delayed_notification',
}

export enum FEATURE_STATES {
  DEFAULT = 'on',
  ON = 'on',
  OFF = 'off',
  REDIRECT = 'redirect',
}
